import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Upload, Radio, Form, Button } from 'antd';
import { InboxOutlined, DeleteOutlined } from '@ant-design/icons';

const { Dragger } = Upload;

const VehicleImagesUpload = ({ props, fileList, setFileList }) => {
  const { t } = useTranslation();

  // Handle radio button change for each image file
  const handleRadioChange = (fileUid, value) => {
    const updatedFileList = fileList.map((file) => {
      if (file.uid === fileUid) {
        // Update the custom 'imageType' property on the file object
        return { ...file, imageType: value };
      }
      return file;
    });
    setFileList(updatedFileList); // Update the fileList state
  };

  // Handle file delete
  const handleDelete = (fileUid) => {
    const updatedFileList = fileList.filter((file) => file.uid !== fileUid);
    setFileList(updatedFileList); // Update the fileList state after delete
  };

  const uploadButton = (
    <div>
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">{t('vehicles.clickOrDrag')}</p>
    </div>
  );

  return (
    <div className="dragger-custom">
      <Dragger
        {...props}
        fileList={fileList}
        showUploadList={false}
        disabled={fileList.length >= props.maxCount}
        onChange={({ fileList }) =>
          setFileList(fileList.filter((file) => file.status !== 'error'))
        }
      >
        {fileList.length >= props.maxCount
          ? t('vehicles.maxImageUploadMessage', { count: props.maxCount })
          : uploadButton}
      </Dragger>

      {/* Render the preview images with type selection */}
      <div
        style={{ marginTop: 16, display: 'flex', gap: '5px', flexWrap: 'wrap' }}
      >
        {fileList.map((file) => (
          <div
            key={file.uid}
            style={{
              marginBottom: 12,
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              width: '32%',
              background: '#fafafa',
              position: 'relative', // For absolute positioning of the delete button
              padding: 8,
              border: '1px solid #d9d9d9',
            }}
          >
            {/* Delete button in the top-right corner */}
            <Button
              type="link"
              icon={<DeleteOutlined />}
              size="small"
              onClick={() => handleDelete(file.uid)}
              style={{
                position: 'absolute',
                top: 4,
                right: 4,
                padding: 0,
                zIndex: 1,
                color: 'red',
              }}
            />
            {/* Image Preview */}
            <img
              src={URL.createObjectURL(file.originFileObj)}
              alt={file.name}
              style={{
                width: 'auto',
                height: '60px',
                objectFit: 'cover',
                marginBottom: 8,
              }}
            />
            {/* Image type selector using Radio buttons */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Form.Item
                name={`imageType_${file.uid}`}
                initialValue={file.imageType}
                style={{ marginBottom: 0 }}
              >
                <Radio.Group
                  value={file.imageType}
                  onChange={(e) => handleRadioChange(file.uid, e.target.value)}
                >
                  <Radio value="exterior" style={{ marginRight: 8 }}>
                    {t('vehicles.imageType.exterior')}
                  </Radio>
                  <Radio value="interior" style={{ marginRight: 8 }}>
                    {t('vehicles.imageType.interior')}
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VehicleImagesUpload;
